// 单文件引入方式

import Month from './ZuiMonth.vue'

export default {
  install(Vue) {
    Vue.component('ZuiMonth', Month)
  }
}

export { Month }
